/* eslint-disable @scandipwa/scandipwa-guidelines/no-jsx-variables */
/* eslint-disable no-unused-vars,@scandipwa/scandipwa-guidelines/use-namespace */

/**
 * @category    ScandiPWA
 * @package     ScandiPWA_CjPublicis
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2022 Scandiweb, Ltd (https://scandiweb.com)
 */

import { BEFORE_ITEMS_TYPE } from 'Component/Router/Router.config';

import CookieScriptContainer from '../component/CookieScript';

export const addCookieComponent = (member, context) => {
    const maxPosition = Math.max(
        // eslint-disable-next-line no-magic-numbers
        member.map((route) => route.position).filter((num) => num <= 1000)
    );

    return [
        ...member,
        {
            component: <CookieScriptContainer />,
            // eslint-disable-next-line no-magic-numbers
            position: maxPosition + 10
        }
    ];
};

export default {
    'Component/Router/Component': {
        'member-property': {
            [BEFORE_ITEMS_TYPE]: addCookieComponent
        }
    }
};
